import { useBreakpointValue } from "@chakra-ui/react";
import { createContext, useContext } from "react";

const Context = createContext({});

export const ContextProvider = ({ children }) => {
  const color = {
    buttonColor: "#D29F68",
    mainColor: "#D29F68",
    secondButton: "#9E9E9EBA",
  };

  const variant = useBreakpointValue({
    base: "base",
    sm: "sm",
    md: "md",
    lg: "lg",
  });

  const paddingX = [3, 3, 3, 3];
  const marginTop = ["30px", "40px", "50px", "40px", "100px"];

  return (
    <Context.Provider
      value={{
        color,
        paddingX,
        marginTop,
        variant,
        isMobile: variant === "base" || variant === "sm",
      }}
    >
      {children}
    </Context.Provider>
  );
};

export function useContaxt() {
  return useContext(Context);
}
